<template>
    <div class="drive-component">

        <div class="list-unstyled list-inline d-flex justify-content-center">
            <span v-if="corridoring && corridoring.distance" class="list-inline-item me-0">
                <span class="small text-muted">distance : {{ corridoring.distance }} km</span>
            </span>
        </div>

        <div class="hrdivider">
            <hr class="border border-primary border-3"/>
            <span class="hrdivider-left"><font-awesome-icon :icon="['fas', 'fa-circle']" size="sm" class="text-primary" /></span>
            <span class="hrdivider-right"><font-awesome-icon :icon="['fas', 'fa-circle']" size="sm" class="text-primary" /></span>
        </div>

        <div class="container">
          <div class="row d-flex">
              <span v-if="corridoring && corridoring.startAddress" class="col-5 small text-muted text-start px-0">{{ corridoring.startAddress }}</span>
              <span v-else class="col-5"></span>
              <span class="col-2"></span>
              <span v-if="corridoring && corridoring.endAddress" class="col-5 small text-muted text-end px-0">{{ corridoring.endAddress }}</span>
          </div>
        </div>

    </div>    
</template>

<script>
export default {
  props: ['corridoring']
}
</script>

<style>
.drive-component {
  width: 100%;
  padding-left: 3%;
  padding-right: 3%;
}

.hrdivider {
  position: relative;
  margin-bottom: -10px;
  margin-top: -5px;
  width: 100%;
}

.hrdivider-left {
  position: absolute;
  top: -8px;
}

.hrdivider-right {
  position: absolute;
  top: -8px;
  right: 0;
}
</style>